var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',_vm._g(_vm._b({attrs:{"color":_vm.color,"dark":_vm.isDark,"light":!_vm.isDark}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label.code))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }